import type { FC } from "react";
import MultiChipDown from "pro-features/components/MultiChipDown/src/MultiChipDown";
import { i18nFilter } from "app/filters/i18nFilter";
import { EllipsisDropdownItem } from "@similarweb/ui-components";
import {
    Intent,
    MAP_CHIPDOWN_TEXT_TO_INTENT_QUERY_TEXT,
    MAP_INTENT_TO_CHIPDOWN_TEXT,
    MAP_INTENT_TO_CHIPDOWN_TOOLTIP_TEXT,
} from "app/pages/website-analysis/traffic-sources/search/common/intent.configuration";
import type { IChipItem } from "pro-features/components/MultiChipDown/src/MultiChipDownTypes";
import { Operator } from "pro-features/components/MultiChipDown/src/MultiChipDownTypes";
import noop from "lodash/noop";
import { allTrackers } from "app/services/track/track";

const filter = i18nFilter();

const KEYWORD_INTENT_MULTI_CHIP_DOWN_OPTIONS = [
    {
        text: MAP_INTENT_TO_CHIPDOWN_TEXT[Intent.Informational],
        id: Intent.Informational,
    },
    {
        text: MAP_INTENT_TO_CHIPDOWN_TEXT[Intent.Navigational],
        id: Intent.Navigational,
    },
    {
        text: MAP_INTENT_TO_CHIPDOWN_TEXT[Intent.Local],
        id: Intent.Local,
    },
    {
        text: MAP_INTENT_TO_CHIPDOWN_TEXT[Intent.Transactional],
        id: Intent.Transactional,
    },
    {
        text: MAP_INTENT_TO_CHIPDOWN_TEXT[Intent.JobSearch],
        id: Intent.JobSearch,
    },
];

const getInitialSelectedItems = (intentsfilter: string) => {
    if (!intentsfilter) {
        return {};
    }
    return intentsfilter.split(",").reduce((accumulatedSelectedItems, intentWord) => {
        return {
            ...accumulatedSelectedItems,
            [intentWord]: true,
        };
    }, {});
};

const intentWithNewIntentText = (item: IChipItem) => {
    return {
        ...item,
        text: MAP_CHIPDOWN_TEXT_TO_INTENT_QUERY_TEXT[item.text],
    };
};

const RenderDropDownItem = (option: { text: string; id: string }) => {
    return (
        <EllipsisDropdownItem
            showCheckBox
            key={option.id}
            id={option.id}
            tooltipText={MAP_INTENT_TO_CHIPDOWN_TOOLTIP_TEXT[option.id]}
        >
            {option.text}
        </EllipsisDropdownItem>
    );
};
interface IKeywordIntentProps {
    intentsfilter: string;
    onIntentChange: (value: IChipItem[]) => void;
    onItemClick?: (selectedItem, selectedItems) => void;
    trackingOnApply?: (selectedItems: IChipItem[]) => void;
    filterTextKey?: string;
}
export const KeywordIntent: FC<IKeywordIntentProps> = (props) => {
    const {
        intentsfilter,
        onIntentChange,
        onItemClick = noop,
        trackingOnApply = noop,
        filterTextKey = "keywords.table.filters.intent.button",
    } = props;

    const formatIntentTextAndChangeIntentFilter = (newIntentsFilterItems: IChipItem[]) => {
        const newIntentsFilterItemsWithFormattedText = newIntentsFilterItems.map(intentWithNewIntentText);
        onIntentChange(newIntentsFilterItemsWithFormattedText);
    };

    const onChipdownToggle = (isOpen: boolean) => {
        if (isOpen) {
            allTrackers.dispatchTrackEvent("Drop Down", "open", "Open Intent filter");
        }
    };

    const trackSelectedItem = ({ id }) => {
        allTrackers.dispatchTrackEvent("Drop Down", "click", `	 select Intent/${id || ""}`);
    };

    return (
        <MultiChipDown
            data-automation="keyword-intent-multi-cheapdown"
            clearSelectionWhenOneOption={false}
            cssClassContainer={`DropdownContent-container keyword-intent-multi-cheapdown`}
            dropdownWidth={280}
            options={KEYWORD_INTENT_MULTI_CHIP_DOWN_OPTIONS}
            initialSelectedItems={getInitialSelectedItems(intentsfilter)}
            buttonText={filter(filterTextKey)}
            onDone={formatIntentTextAndChangeIntentFilter}
            getDropdownItem={RenderDropDownItem}
            titleOperator={Operator.Or}
            onToggleDropdown={onChipdownToggle}
            onSelectItem={trackSelectedItem}
            onItemClick={onItemClick}
            trackingOnApply={trackingOnApply}
        />
    );
};
